"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _ykbTextMask = require("ykb-text-mask");
var _excluded = ["showMask", "onChange", "value", "inputRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function getShadowRoot(renderOnBody) {
  if (!renderOnBody) {
    try {
      return document.querySelector('#page-tabs .tab-pane.active sparx-process').shadowRoot;
    } catch (error) {}
  }
}
var withMask = function withMask(ComposedInput) {
  return /*#__PURE__*/function (_React$Component) {
    function _class() {
      (0, _classCallCheck2.default)(this, _class);
      return _callSuper(this, _class, arguments);
    }
    (0, _inherits2.default)(_class, _React$Component);
    return (0, _createClass2.default)(_class, [{
      key: "initTextMask",
      value: function initTextMask() {
        var props = this.props,
          _this$props = this.props,
          value = _this$props.value,
          renderOnBody = _this$props.renderOnBody;
        this.textMaskInputElement = (0, _ykbTextMask.createTextMaskInputElement)(_objectSpread({
          inputElement: this.inputElement,
          shadowRoot: getShadowRoot(renderOnBody)
        }, props));
        this.textMaskInputElement.update(value);
        if (typeof value !== 'undefined') this.inputElement.setAttribute('unmaskedValue', value);
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.mask) this.initTextMask();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.mask) this.initTextMask();
      }
    }, {
      key: "handleChange",
      value: function handleChange(e) {
        this.textMaskInputElement.update();
        var maskedValue = e.target.value;
        var unmaskedValue = maskedValue;
        if (this.props.unMask) unmaskedValue = this.props.unMask(maskedValue);
        this.inputElement.setAttribute('unmaskedValue', unmaskedValue);
        if (this.props.onChange) {
          this.props.onChange(e, unmaskedValue, maskedValue);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this = this;
        var _this$props2 = this.props,
          showMask = _this$props2.showMask,
          onChange = _this$props2.onChange,
          value = _this$props2.value,
          _inputRef = _this$props2.inputRef,
          props = (0, _objectWithoutProperties2.default)(_this$props2, _excluded);
        // delete props.mask;
        delete props.guide;
        delete props.pipe;
        delete props.placeholderChar;
        delete props.keepCharPositions;
        // delete props.onChange;
        // delete props.value;

        return /*#__PURE__*/_react.default.createElement(ComposedInput, (0, _extends2.default)({}, props, {
          inputRef: function inputRef(inputEl) {
            _this.inputElement = inputEl;
            if (_inputRef) _inputRef(inputEl);
          },
          onInput: function onInput(e) {
            return _this.handleChange(e);
          }
        }));
      }
    }]);
  }(_react.default.Component);
};
var _default = exports.default = withMask;